import MDTypography from "components/MDTypography";
import React, { useState, useEffect } from "react";
import { application } from "globals/endpoints";
import { IconButton } from "@mui/material";

function QueueCell({ row, value }) {
  let systemName = row?.original?.data;
  const [listOptions, setListOptions] = useState([]);

  useEffect(() => {
    application.post("queue/listAll/queue").then((response) => {
      setListOptions(response.data.data);
    });
  }, []);

  const matchedSeverity = listOptions.find(
    (option) => option?.systemName === systemName
  );

  return (
    <MDTypography variant="caption" fontWeight="medium" color="#FFFFFFCC">
      <IconButton
        style={{
          backgroundColor: matchedSeverity ? matchedSeverity.color : "",
          width: "30px",
          height: "30px",
          borderRadius: "50%",
        }}
      ></IconButton>
      {matchedSeverity ? (
        <MDTypography variant="caption" fontWeight="medium" color="#FFFFFFCC">
          &nbsp;&nbsp;&nbsp;
          {matchedSeverity.description}
        </MDTypography>
      ) : (
        <MDTypography variant="caption" fontWeight="medium" color="#FFFFFFCC">
          &nbsp;&nbsp;&nbsp;
          {value}
        </MDTypography>
      )}
    </MDTypography>
  );
}

export default QueueCell;
